import React, { useRef, useEffect } from 'react';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('ProductDetails');

/* 
scrolling down
    1 - reached the end of the component - position = fixed
    2 - reached the end of the page - position = relative 
    3 - changing the scroll direction - position = relative
scrolling up
    1 - reached the top of the component - position = fixed
    2 - reached the top of the page - position = relative 
    3 - changing the scroll direction - position = relative
*/

const LOCK_GAP = 10;
const MARGIN_TOP = 80;

export default function ProductDetailsFullBleedWrapper({ children }) {
    const detailsRef = useRef();
    const wrapperRef = useRef();
    let lastScrollTop = 0;

    function setElementStyle(position, top = '0px', marginTop = '0px') {
        const el = detailsRef.current;
        if (el.style.position !== position) {
            el.style.position = position;
            el.style.top = top;
            el.style.marginTop = marginTop;
            if (position === 'fixed') el.style.width = `${wrapperRef.current.clientWidth}px`;
        }
    }

    function productDetailsPosition() {
        const element = detailsRef.current;
        const elementRect = element?.getBoundingClientRect();
        const windowScrollY = window.scrollY;

        //content fits page
        if (element.offsetHeight < window.innerHeight) {
            setElementStyle('sticky', '', '');
        } else {
            const scroll = windowScrollY || document.documentElement.scrollTop;
            const parentoffsetHeight = wrapperRef.current.offsetHeight;
            const hasReachedPageBottom = window.innerHeight >= wrapperRef.current.getBoundingClientRect().bottom;
            const hasReachedPageTop = windowScrollY <= wrapperRef.current.offsetTop;
            const hasReachedComponentTop = elementRect.top - MARGIN_TOP >= 0;
            const hasReachedComponentBottom = window.innerHeight + LOCK_GAP >= elementRect.bottom;
            const scrollingDown = scroll > lastScrollTop;

            if (scrollingDown) {
                if (hasReachedComponentBottom) {
                    if (hasReachedPageBottom) {
                        setElementStyle('relative', '0px', `${parentoffsetHeight - LOCK_GAP - element.offsetHeight}px`);
                    } else {
                        //changing the scroll direction
                        setElementStyle('fixed', `${window.innerHeight - element.offsetHeight}px`);
                    }
                }
                if (!hasReachedComponentBottom && !hasReachedPageBottom) {
                    setElementStyle('relative', '0px', `${windowScrollY - wrapperRef.current.offsetTop + elementRect?.top}px`);
                }
            } else {
                if (hasReachedComponentTop && !hasReachedPageBottom) {
                    if (hasReachedPageTop) {
                        setElementStyle('relative', '0px', `${MARGIN_TOP}px`);
                    } else {
                        //changing the scroll direction
                        if (!hasReachedPageBottom) {
                            setElementStyle('fixed', '0px', `${MARGIN_TOP}px`);
                        }
                    }
                } else {
                    if (!hasReachedPageBottom) {
                        setElementStyle('relative', '0px', `${windowScrollY - wrapperRef.current.offsetTop + elementRect?.top}px`);
                    }
                }
            }
            lastScrollTop = scroll <= 0 ? 0 : scroll;
        }
    }

    useEffect(() => {
        document.addEventListener('scroll', productDetailsPosition);
        return () => document.removeEventListener('scroll', productDetailsPosition);
    }, []);

    return (
        <div className={bem('productDetailsWrapper')} ref={wrapperRef}>
            <div ref={detailsRef} className={bem('productDetailsContent')}>
                {children}
            </div>
        </div>
    );
}
